import * as React from "react";
import { sortBy } from "lodash";
import { ClientInsuranceModel } from "@app/insurance";
import { JSX } from "react";

export interface InsurancesProps {
  availableInsurances: ClientInsuranceModel[];
}

export const InsurancesContext = React.createContext<Partial<InsurancesProps>>({});

/**
 * This context serves to fetch the list of all available (not assigned) Insurances for a given client.
 */
export const InsurancesProvider = ({ availableInsurances, children }: { availableInsurances: ClientInsuranceModel[], children: React.ReactNode }): JSX.Element => {

  return (
    <InsurancesContext.Provider
      value={{
        availableInsurances: sortBy(availableInsurances, (insurance) => insurance.planName, "asc")
      }}
    >
      { children}
    </InsurancesContext.Provider>
  );
};
